import { ComponentProps } from 'react';

import { MergeVariantProps } from '../cva';
import { ButtonVariantProps, buttonVariants } from './variants';

export type ButtonProps = MergeVariantProps<
    ComponentProps<'button'>,
    ButtonVariantProps
>;

export function Button({ color, variant, ...props }: ButtonProps) {
    return (
        <button
            {...props}
            className={buttonVariants({ ...props, color, variant })}
        />
    );
}
